import { render, staticRenderFns } from "./FacetDetail.vue?vue&type=template&id=3197ce66&"
import script from "./FacetDetail.vue?vue&type=script&lang=js&"
export * from "./FacetDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

component.options.__file = "FacetDetail.vue"
export default component.exports